export interface EquipmentItem {
  id: string;
  name: { hr: string; en: string };
  tags: { hr: string[]; en: string[] };
  /** Stable filter key — not displayed, so it doesn't need a translation. */
  category: string;
  image: string;
  description: { hr: string; en: string };
}

export const EQUIPMENT: EquipmentItem[] = [
  {
    id: "1",
    name: { hr: "Nautilus Pullover", en: "Nautilus Pullover" },
    tags: { hr: ["Leđa"], en: ["Back"] },
    category: "machines",
    image: "/img/equipment/Nautilus-Inspiration-Pull-Over.webp",
    description: {
      hr: "Klasična sprava za izolirano jačanje širokog leđnog mišića i stabilizatora ramena kroz pokret povlačenja iznad glave. Prepoznatljiva Nautilus krivulja opterećenja prati prirodnu snagu mišića kroz cijeli raspon pokreta.",
      en: "A classic machine for isolated strengthening of the lats and shoulder stabilizers through an overhead pulling motion. The signature Nautilus resistance curve follows the muscle's natural strength through the full range of motion.",
    },
  },
  {
    id: "2",
    name: { hr: "Iso-Lateral Leg Press", en: "Iso-Lateral Leg Press" },
    tags: { hr: ["Noge"], en: ["Legs"] },
    category: "machines",
    image: "/img/equipment/Iso-Lateral_Leg_Press.webp",
    description: {
      hr: "Sprava za potisak nogu s neovisnim pokretom svake strane, što omogućuje ravnomjeran razvoj snage i ispravlja asimetrije. Pogodna za jačanje kvadricepsa, stražnjice i zadnje lože natkoljenice.",
      en: "A leg press machine with independent movement on each side, enabling even strength development and correcting imbalances. Great for building the quads, glutes, and hamstrings.",
    },
  },
  {
    id: "3",
    name: { hr: "Smith Mašina", en: "Smith Machine" },
    tags: { hr: ["Cijelo tijelo"], en: ["Full body"] },
    category: "machines",
    image: "/img/equipment/smith_machine.webp",
    description: {
      hr: "Univerzalna sprava s vođenom okomitom putanjom šipke koja omogućuje sigurno izvođenje čučnjeva, potisaka i drugih osnovnih vježbi bez potrebe za asistencijom. Idealna za početnike i naprednije korisnike.",
      en: "A versatile machine with a guided vertical bar path that allows safe squats, presses, and other basic exercises without a spotter. Ideal for beginners and advanced users alike.",
    },
  },
  {
    id: "4",
    name: { hr: "Stair master", en: "Stair Master" },
    tags: { hr: ["Noge"], en: ["Legs"] },
    category: "machines",
    image: "/img/equipment/stairmaster.jfif",
    description: {
      hr: "Kardio sprava koja simulira penjanje stubama, izvrsna za jačanje nogu i stražnjice uz visoku potrošnju kalorija. Podesivi intenzitet omogućuje trening prilagođen svim razinama kondicije.",
      en: "A cardio machine that simulates climbing stairs, excellent for building the legs and glutes while burning plenty of calories. Adjustable intensity suits every fitness level.",
    },
  },
  {
    id: "5",
    name: { hr: "Hammer Hack Squat", en: "Hammer Hack Squat" },
    tags: { hr: ["Noge"], en: ["Legs"] },
    category: "machines",
    image: "/img/equipment/hammer-strength-hack-squat.webp",
    description: {
      hr: "Sprava za čučnjeve s nagnutom, vođenom putanjom koja rasterećuje donji dio leđa uz snažnu aktivaciju kvadricepsa. Sigurnosni osloni omogućuju rad s velikim opterećenjima bez asistencije.",
      en: "A squat machine with an angled, guided path that takes pressure off the lower back while strongly engaging the quads. Safety stops allow heavy loading without a spotter.",
    },
  },
  {
    id: "6",
    name: { hr: "Hammer Incline Chest Press", en: "Hammer Incline Chest Press" },
    tags: { hr: ["Gornji dio prsa"], en: ["Upper chest"] },
    category: "machines",
    image: "/img/equipment/hammer-strength-incline-press.webp",
    description: {
      hr: "Iso-lateralna sprava za potisak pod kutom namijenjena razvoju gornjeg dijela prsnih mišića i prednjih ramena. Neovisan pokret svake ruke poboljšava simetriju i kontrolu tijekom vježbe.",
      en: "An iso-lateral incline press machine built to develop the upper chest and front shoulders. Independent arm movement improves symmetry and control throughout the exercise.",
    },
  },
  {
    id: "7",
    name: { hr: "Hammer Chest Press", en: "Hammer Chest Press" },
    tags: { hr: ["Srednji dio prsa"], en: ["Mid chest"] },
    category: "machines",
    image: "/img/equipment/Hammer_Strength_Chest_press.webp",
    description: {
      hr: "Iso-lateralna sprava za razvoj prsnih mišića koja omogućuje neovisan pokret svake ruke, čime se poboljšava simetrija i aktivacija mišića. Idealna za progresivno opterećenje kroz sigurnu, kontroliranu putanju pokreta.",
      en: "An iso-lateral machine for chest development that allows independent movement of each arm, improving symmetry and muscle activation. Ideal for progressive loading through a safe, controlled path.",
    },
  },
  {
    id: "8",
    name: { hr: "Hammer Wide Chest Press", en: "Hammer Wide Chest Press" },
    tags: { hr: ["Vanjski dio prsa"], en: ["Outer chest"] },
    category: "machines",
    image: "/img/equipment/hammer-strength-iso-lateral-wide-chest.webp",
    description: {
      hr: "Sprava sa širim hvatom namijenjena naglašenoj aktivaciji vanjskog dijela prsnih mišića. Iso-lateralni dizajn omogućuje prirodniju putanju pokreta i bolju kontrolu opterećenja.",
      en: "A wide-grip machine built to emphasize the outer chest. The iso-lateral design allows a more natural movement path and better control of the load.",
    },
  },
  {
    id: "9",
    name: { hr: "Hammer Iso-Lateral Row", en: "Hammer Iso-Lateral Row" },
    tags: { hr: ["Leđa"], en: ["Back"] },
    category: "machines",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-later-rowing-machine.webp",
    description: {
      hr: "Sprava za veslanje s neovisnim pokretom svake ruke, namijenjena jačanju širine i debljine leđnih mišića. Opterećenje pločicama omogućuje postupno povećanje intenziteta treninga.",
      en: "A rowing machine with independent arm movement, built to develop back width and thickness. Plate-loaded resistance allows gradual increases in training intensity.",
    },
  },
  {
    id: "10",
    name: { hr: "Booty Builder / Back Extension", en: "Booty Builder / Back Extension" },
    tags: { hr: ["Gluteus", "Donja leđa"], en: ["Glutes", "Lower back"] },
    category: "machines",
    image: "/img/equipment/BB_Backextension.webp",
    description: {
      hr: "Sprava specijalizirana za jačanje gluteusa kroz pokret ekstenzije kuka, uz mogućnost izvođenja i ekstenzije leđa. Podesivo opterećenje i udoban jastuk omogućuju siguran trening za sve razine iskustva.",
      en: "A machine specialized for glute strengthening through hip extension, with the option to perform back extensions as well. Adjustable resistance and a comfortable pad make it safe for all experience levels.",
    },
  },
  {
    id: "11",
    name: { hr: "Technogym Iso-Lateral High Row", en: "Technogym Iso-Lateral High Row" },
    tags: { hr: ["Leđa"], en: ["Back"] },
    category: "machines",
    image: "/img/equipment/Iso-Lat-High-Row.webp",
    description: {
      hr: "Sprava za povlačenje iz visokog položaja koja cilja gornji dio leđa i stražnje ramene mišiće. Neovisan pokret svake ruke osigurava ravnomjeran razvoj snage s obje strane tijela.",
      en: "A high-row pulling machine that targets the upper back and rear shoulder muscles. Independent arm movement ensures even strength development on both sides of the body.",
    },
  },
  {
    id: "12",
    name: { hr: "Hip Thrust (Smith Machine)", en: "Hip Thrust (Smith Machine)" },
    tags: { hr: ["Gluteus"], en: ["Glutes"] },
    category: "machines",
    image: "/img/equipment/hip-thrust-machine-with-smith.webp",
    description: {
      hr: "Prilagodba Smith mašine namijenjena izvođenju hip thrust pokreta uz vođenu, sigurnu putanju šipke. Izvrsna za ciljano jačanje gluteusa uz mogućnost progresivnog povećanja opterećenja.",
      en: "A Smith machine adaptation built for the hip thrust movement with a guided, safe bar path. Excellent for targeted glute strengthening with the option to progressively increase load.",
    },
  },
  {
    id: "13",
    name: { hr: "Hammer Plate Load Shoulder Press ISO", en: "Hammer Plate Load Shoulder Press ISO" },
    tags: { hr: ["Ramena"], en: ["Shoulders"] },
    category: "machines",
    image: "/img/equipment/hammer-strength-plate-loaded-iso-lateral-shoulder-press.webp",
    description: {
      hr: "Iso-lateralna sprava za potisak iznad glave namijenjena jačanju ramena uz kontroliranu, sigurnu putanju pokreta. Neovisan rad svake ruke pomaže u ispravljanju asimetrija u snazi.",
      en: "An iso-lateral overhead press machine built to strengthen the shoulders through a controlled, safe movement path. Independent arm operation helps correct strength imbalances.",
    },
  },
  {
    id: "14",
    name: { hr: "PULL/PUSH saonice", en: "Push/Pull Sled" },
    tags: { hr: ["Cijelo tijelo", "Kardio"], en: ["Full body", "Cardio"] },
    category: "machines",
    image: "/img/equipment/Prowler-Sled-Push-Pull-per-Allen.webp",
    description: {
      hr: "Saonice za guranje i povlačenje namijenjene funkcionalnom treningu snage i kondicije cijelog tijela. Svestran alat za razvoj eksplozivnosti, izdržljivosti i snage nogu bez opterećenja zglobova udarcima.",
      en: "A push-pull sled built for functional full-body strength and conditioning training. A versatile tool for developing explosiveness, endurance, and leg strength without joint-impact stress.",
    },
  },
];

export const POPULAR_EQUIPMENT_IDS = ["10", "1"];

export function localizeEquipment(item: EquipmentItem, locale: "hr" | "en") {
  return {
    id: item.id,
    name: item.name[locale],
    tags: item.tags[locale],
    category: item.category,
    image: item.image,
    description: item.description[locale],
  };
}
